//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from "@/const/const"
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'
import {directTurnIntoBase64, photoCompress, canvasDataURL} from '@/assets/js/util'

export default {
    name: "LoadImgUpload",
    components: {
        MyBtnReturn,
    },
    data() {
        return {
            bookingId: '',
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: require('@/assets/images/plan/wx_zhuang_blue.png'), // 装箱的图片，右上角的icon
            uploadLoadSrc: require('@/assets/images/wx_zx_tp.png'), // 装箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: require('@/assets/images/wx_fx_tp.png'), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            imgSrc: '', // 一开始为uploadLoadSrc或uploadSealSrc，之后为用户上传的图片
            fileUrl: '', // 上传成功后返回的图片路径
            iconClose: require('@/assets/images/wx_sc_oringe.png'), // 关闭图标
            isShowLoading: false,
            canUpload: true,
            isUploaded: false, // 是否已经上传成功，true代表已经上传成了
            goBackQuery: {}, // 回退时要带的参数
            uploadUrl: '',
            step: -2,
            inputFiles: [{imgSrc: null}]
        }
    },
    created() {
        document.title = '装货图片';
        let query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype,
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常
        // 出现上述bug的原因：页面的url被拼接了一个问号，变成/?#/这种情况，然后刷新一次页面，再进入这个组件，导致数据丢失，而且用go回退时要两次！
        // 上述Bug后，如果使用go回退，那apiParams里的属性在这里设置也没用，还是初始化为空字符串了，可能要保存在sessionStorage了，
        // 或者后台去将companyId与openId保存在session里
        // =>最新进展：后台保存在session里了
        if (!apiParams.companyId) { // 如果apiParams.companyId变回空字符串了，证明页面被刷新了
            console.error('companyId被弄没了');
            apiParams.companyId = query.companyId2;
            apiParams.openId = query.openId2;
            this.step = -2
        }
        // 判断是装箱的，还是封箱的
        // 可以异步上传图片了，不用麻烦后台重定向了
        // let resultUrl = `#/load-upload-result?companyId=${apiParams.companyId}&openId=${apiParams.openId}&ladingId=${query.ladingId}&id=${query.id}&referenceno=${query.referenceno}&cont_no=${query.contNo}&type=${query.type}`
        if (query.type === 'load') {
            this.imgSrc = this.uploadLoadSrc;

            // this.uploadUrl = `${apiUrl.loadImgUpload}?companyId=${apiParams.companyId}&openId=${apiParams.openId}&ladingId=${query.ladingId}&id=${query.id}&referenceno=${query.referenceno}&cont_no=${query.contNo}&resultUrl=${resultUrl}`
            this.uploadUrl = apiUrl.loadImgUpload
        } else {
            this.imgSrc = this.uploadSealSrc;
            // this.uploadUrl = `${apiUrl.uploadSealController}?companyId=${apiParams.companyId}&openId=${apiParams.openId}&ladingId=${query.ladingId}&id=${query.id}&referenceno=${query.referenceno}&cont_no=${query.contNo}&resultUrl=${resultUrl}`
            this.uploadUrl = apiUrl.uploadSealController
        }
    },
    methods: {
        getImg(e) {
            // 如果用户选择图片时，按了取消/撤销，那e.target.files[0]会变为undefined，此时要阻止后续操作
            if (!e.target.files[0]) return;
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.file = e.target.files[0];
            // 如果图片超过2M，才进行压缩：因为现在限制10M内，但还是尽量别上传太大图片，所以大于2M还是压缩一次吧
            // 新需求：大于512K的，都进行压缩
            if (this.file.size / 1024 > 513) {
                // 压缩图片
                photoCompress(this.file, {
                    quality: 0.5,
                    minSize: 513,
                }, (base64Img) => {
                    this.$vux.loading.hide();
                    this.imgSrc = base64Img
                }, () => {
                    // 图片经过多次压缩，还是太大了，提示用户
                    this.$vux.loading.hide();
                    this.showToast('抱歉，图片太大', 2000)
                })
            } else {
                // 小于512K的，直接用，不压缩了
                directTurnIntoBase64(this.file, (base64Img) => {
                    this.$vux.loading.hide();
                    this.imgSrc = base64Img
                })
            }
        },
        resetImg() {
            // 这个方法是.icon-close的方法，只是删除下已加载的图片
            if (this.type === 'load') {
                this.imgSrc = this.uploadLoadSrc
            } else {
                this.imgSrc = this.uploadSealSrc
            }
            // bug:如果resetImg了，在resetImg中没有将input获取到的file清空的话，那用户紧接着又选同一张图片，是无法触发change事件的！
            // 处理上述bug：因此要将其value变为空字符串
            this.$refs.inputFile.value = '';
            this.file = ''
        },
        uploadImg() {
            // 如果已经上传成功了，不给继续上传
            if (this.isUploaded) {
                this.showToast('已上传图片了，请返回上一页面继续操作！');
                return
            }
            // 提交前先验证下有没选择图片了
            if (!this.canUpload) return;
            this.canUpload = false;
            if (this.file) {

            } else {
                this.showToast('请先选择图片');
                this.canUpload = true;
                return
            }
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 上传图片：该接口需要'Content-Type': 'multipart/form-data'；因此要将图片文件与其他参数都放进FormData实例中
            let param = {
                base64Img: this.imgSrc,  // 现在上传图片的格式为base64的
                companyId: apiParams.companyId,
                openId: apiParams.openId,
                bookingId: this.bookingId,
                ladingId: this.ladingId,
                id: this.id,
                referenceno: this.referenceno,
                cont_no: this.contNo
            };
            let config = { // 如果已经使用FormData对象作为参数了，那不用设置这个请求头了，会自动修改为这个content-type的
                headers: {'Content-Type': 'multipart/form-data'}
            }; //添加请求头
            let url = this.uploadUrl;
            // this.$http.post(apiUrl.uploadDelive, param, config) // 用已序列化数据的方式会直接报500
            this.requestApi({
                    url: url,
                    data: param
                },
                (res) => {
                    //{"code":200,"data":{"fileUrl":"/api/upload/aohy/a4266e1e31f942ba89246656dd3ffce7.png"}}
                    let resultData = res.data; // 后台返回结果data数据
                    let code = res.code;
                    let info = resultData.info; // 412或500的提示语
                    if (code === 412) {
                        this.showToast(info, 1500, 'warn')
                    } else if (code === 500) {
                        this.showToast(info, 1500, 'warn')
                    } else {
                        this.isUploaded = true;
                        this.showToast('上传成功！', 2000, 'success', {
                            onHide: () => {
                                this.showToast('请返回上一页面继续操作。', 2000)
                            }
                        });
                    }
                    this.canUpload = true;
                    this.$vux.loading.hide()
                },
                (error) => {
                    this.canUpload = true;
                    this.$vux.loading.hide();
                    // if (error.response) {
                    //   // 请求已发出，但服务器响应的状态码不在 2xx 范围内
                    //   if (error.response.status === 413) {
                    //     this.showToast('图片太大，上传失败！', 2000,'cancel')
                    //   } else {
                    //     this.showToast('上传失败！', 2000,'cancel')
                    //   }
                    // } else {
                    if (error) {
                        console.error(error);
                        this.showToast('上传失败！', 2000, 'cancel')
                    }
                    // }
                }
            )
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/siji/loadImg/LoadImgUpload.vue